import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import {
  CostProfile,
  CostProfileCostsHistory,
  Identifiable,
} from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  history: CostProfileCostsHistory;
  retrieveCostProfileCostsHistory(
    data: Boundaries["retrieveCostProfileCostsHistory"]["request"],
  ): void;
}

function useRetrieveCostProfileCostsHistory(
  costProfile: Identifiable<CostProfile>,
): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isRetrieveCostProfileCostsHistoryRequestPending(costProfile),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isRetrieveCostProfileCostsHistoryRequestSuccess(costProfile),
    ),
    isRequestFailure: useSelector(() =>
      selector.isRetrieveCostProfileCostsHistoryRequestFailure(costProfile),
    ),
    history: useSelector(() =>
      selector.getCostProfileCostsHistory(costProfile),
    ),
    retrieveCostProfileCostsHistory: core.retrieveCostProfileCostsHistory,
  };
}

export { useRetrieveCostProfileCostsHistory };
